import { render, staticRenderFns } from "./BaseButtons.vue?vue&type=template&id=39f4a2f5&"
import script from "./BaseButtons.vue?vue&type=script&lang=ts&"
export * from "./BaseButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports